import {ConfigurationTemplateService} from "./ConfigurationTemplateService";
import {ApplicationService} from "@hec/models";

export const requiredConfigurationTemplateServices = (): ApplicationService[] => {
  return [
    new ConfigurationTemplateService()
  ];
}
